import { CpErrorWarning } from "./CpErrorWarning";

interface Props {
  names: string[];
}

export function CpErrorWarningArray({ names }: Props) {
  return (
    <div style={{ minHeight: 20 }}>
      {names.map((name) => (
        <CpErrorWarning key={name} name={name} arrayItem />
      ))}
    </div>
  );
}
